import {get} from 'lodash'

const defaultPreferences = {
  subscriptions: [],
  uuid: null,
  email: null
}

const defaultNewsletterPage = {
  action: 'preferences',
  signedParams: {}
}

const defaultCsrfToken = {
  token: null
};

export const state = get(window, '__STATE__', {
  newsletterPreferences: defaultPreferences,
  newsletterPage: defaultNewsletterPage,
  csrfSymfony: defaultCsrfToken
});
